module.exports = __webpack_public_path__ + "static/media/GalleryMain12.2bbf49f8.jpg";